import { IHero } from "@src/components/Hero";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import { getCookie } from "cookies-next";
import { useTransform, useViewportScroll, motion } from "framer-motion";
import Image from "next/image";
import React from "react";
import image from "../../../../public/images/image10.png";
import Dialog from "@src/components/Dialog";
import Invitation from "src/components/modals/Invitation";

const Hero: React.FC<IHero> = ({
  eventId,
  heroImageData,
  slugData,
  loading,
  eventUuid,
}) => {
  const { scrollY } = useViewportScroll();
  const y1 = useTransform(scrollY, [0, 300], [0, 60]);
  const currentAccessToken = getCookie("tsl") as string;
  const [show, setShow] = React.useState<boolean>(false);
  const [openRsvp, setOpenRsvp] = React.useState<boolean>(false);

  React.useEffect(() => {
    setShow(true);
  }, []);

  return (
    <div className="w-full h-[100vh] relative overflow-hidden">
      {/* Header */}
      <motion.header
        initial={{ opacity: 0, y: -20 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
            ease: [0.79, 0.14, 0.15, 0.86],
          },
        }}
        className="absolute h-12 bg-[rgba(236,228,237,1)] flex justify-center items-center top-0 left-0 w-full z-[5] px-4"
      >
        <div className="w-full px-2 md:px-6 flex justify-center">
          {/* Ornamental Border Only */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{
              opacity: 1,
              x: 0,
              transition: {
                delay: 0.2,
                duration: 0.6,
              },
            }}
            className="w-full h-4 relative"
            style={{
              backgroundImage: `url('/images/Frame (3).svg')`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top",
              // filter: "invert(1)", // Makes black ornament white
            }}
          />
        </div>
      </motion.header>

      {/* Background Image */}
      <motion.div
        initial={{ scale: 1 }}
        animate={{
          scale: 1.1,
          transition: {
            delay: 0.3,
            duration: 0.8,
            ease: [0.79, 0.14, 0.15, 0.86],
          },
        }}
        className={
          "relative top-0 bottom-0 right-0 left-0 w-full h-full after:absolute after:w-full after:h-full after:bg-template-2-hero"
        }
      >
        <Image
          // placeholder="blur"
          loading="eager"
          layout="fill"
          // blurDataURL={`data:image/svg+xml;base64,${toBase64(
          // shimmer(700, 475)
          // )}`}
          src={
            !!heroImageData.getHeroImage ? heroImageData.getHeroImage : image
          }
          alt="gallery-image"
          className="object-cover object-center"
        />
      </motion.div>

      {/* Main Content */}
      <div className="w-full h-full absolute left-0 top-12 z-[4]">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{
            opacity: 1,
            transition: {
              delayChildren: 1,
              staggerChildren: 1.5,
            },
          }}
          viewport={{ once: true }}
          className={"w-full h-full flex flex-col justify-start px-6"}
        >
          <motion.h5
            initial={{ opacity: 0, y: 30 }}
            whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 1,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className={
              "text-[2.5rem] lg:text-[3rem] text-white font-silver font-light mb-4 mt-8 leading-[100%] capitalize"
            }
          >
            {slugData?.eventBySlug?.name}
          </motion.h5>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 1,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="font-light font-sans uppercase text-[1rem] sm:text-[1.5rem] text-white leading-[100%] mb-[1rem]"
          >
            {slugData?.eventBySlug?.hash_tag}
          </motion.p>

          {currentAccessToken ? (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{
                opacity: 1,
                y: 0,
                transition: {
                  duration: 1,
                  ease: [0.79, 0.14, 0.15, 0.86],
                },
              }}
              className="flex"
            >
              <Dialog
                trigger={
                  <motion.div
                    // style={{ y: y1 }}
                    className="mt-2 bg-[rgba(81,80,80,0.92)] border border-white font-sans text-white px-6 py-2 flex items-center justify-center rounded"
                    onClick={() => setOpenRsvp(true)}
                  >
                    RSVP
                  </motion.div>
                }
                open={openRsvp}
                onOpenChange={setOpenRsvp}
              >
                <Invitation
                  name={slugData?.eventBySlug?.name ?? ""}
                  date={slugData?.eventBySlug?.date ?? ""}
                  eventId={eventId}
                  setOpen={setOpenRsvp}
                  access_control={
                    slugData?.eventBySlug?.event_preference?.access_control ??
                    false
                  }
                  eventUuid={`${slugData?.eventBySlug?.uuid}`}
                  eventSlug={slugData?.eventBySlug?.slug ?? ""}
                  passImage={slugData?.eventBySlug?.pass_image ?? ""}
                />
              </Dialog>
            </motion.div>
          ) : (
            <></>
          )}

          {/* <motion.div className="relative h-[19%] w-full max-w-[29.3rem] mb-4 md:mb-0">
            <Image
              placeholder="blur"
              loading="eager"
              layout="fill"
              src={weddingLogo}
              alt="gallery-image"
              className="object-contain"
            />
          </motion.div> */}
          {/* <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 1,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="text-[2rem] md:text-[4rem] text-white leading-[120%] tracking-[0.2rem] font-dacing"
          >
            #theKSnuptials24
          </motion.p> */}
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
